import React from "react"
import { Transformation } from "cloudinary-react"
import Section from "./section"
import DfbHeadline from "../ui-kit/dfb_headline"
import CCardFact from "../elements/c_card_fact"
import DfbImage from "../ui-kit/dfb_image"

const MCardRowFacts = ({ data }) => {
  const { headline, image, facts } = data
  const img = image?.[0]

  return (
    <Section baseClass="m-CardRow" defaultPadding="large" data={data}>
      <div className="m-CardRow-wrapper">
        <div className="m-CardRow-container">
          {headline && (
            <DfbHeadline
              headline={headline}
              headline_level="h2"
              add_class="m-CardRow-headline"
            />
          )}
        </div>
      </div>

      {img && (
        <div className="m-CardRow-wrapper m-CardRow-wrapper--image">
          <div className="m-CardRow-container">
            <div className="m-CardRow-image">
              <DfbImage image={img} aspect_ratio="16:9" cover>
                <Transformation
                  crop="fill"
                  gravity="faces:center"
                  width="1120"
                  height="630"
                  quality="auto"
                  fetchFormat="auto"
                />
              </DfbImage>
              {img?.copyright && (
                <div className="m-CardRow-copyright">{img?.copyright}</div>
              )}
            </div>
          </div>
        </div>
      )}

      <div className="m-CardRow-wrapper">
        <div className="c-CardRow c-CardRow--facts">
          <div className="c-CardRow-container">
            {facts &&
              facts.map((item, index) => {
                return (
                  <div className="c-CardRow-card" key={index}>
                    <CCardFact
                      type={item.facts_layout}
                      headline={item.facts_headline}
                      subline={item.facts_sub_headline}
                      icon={item.facts_icon}
                      description={item.facts_text}
                      anchor={item.facts_link_text}
                      href={item.facts_link}
                    />
                  </div>
                )
              })}
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MCardRowFacts
